import { render } from "./categoryList.vue?vue&type=template&id=3a4d4ea8&scoped=true"
import script from "./categoryList.vue?vue&type=script&lang=js"
export * from "./categoryList.vue?vue&type=script&lang=js"

import "./categoryList.vue?vue&type=style&index=0&id=3a4d4ea8&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4d4ea8"]])

export default __exports__